import React from 'react';
import PropTypes from 'prop-types';

import './InfoBox.css';

const InfoBox = ({
  title, titleRight, children, className,
}) => {
  return (
    <div className={`infoBox box ${className}`}>
      <div className="level is-mobile infoBox-title">
        <div className="level-left">
          <h4 className="infoBox-title">{title}</h4>
        </div>
        <div className="level-right">{titleRight}</div>
      </div>

      <div className="infoBox-content">{children}</div>
    </div>
  );
};

InfoBox.propTypes = {
  title: PropTypes.string.isRequired,
  titleRight: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};

InfoBox.defaultProps = {
  titleRight: null,
  children: null,
  className: '',
};

export default InfoBox;



// WEBPACK FOOTER //
// ./src/components/common/InfoBox.jsx